import { StyledSkyscraperAdSenseSrpContainer } from '@/components-page/srp/advertisement/styled'
import { type AdSenseProps, AdSense } from '@/features/advertisement/components/adsense/AdSense'

export type SkyscraperAdSenseSrpContainerProps = AdSenseProps & {
  children?: React.ReactNode
  isAdsReinventionExperimentEnabled?: boolean
  adsReinventionExperimentGroup?: number
}

export const SkyscraperAdSenseSrpContainer = ({
  id,
  children,
  isAdsReinventionExperimentEnabled = false,
  adsReinventionExperimentGroup = 0,
}: SkyscraperAdSenseSrpContainerProps) => {
  if (isAdsReinventionExperimentEnabled && adsReinventionExperimentGroup > 0) {
    return (
      <StyledSkyscraperAdSenseSrpContainer
        position={id === 'AFSTop' ? 'top' : 'bottom'}
        data-testid="adsense-container"
        adsReinventionExperimentGroup={adsReinventionExperimentGroup}
      >
        <AdSense id={id} />
        {children}
      </StyledSkyscraperAdSenseSrpContainer>
    )
  }
  return null
}
